import { TYPES as POPOVER_TYPES } from 'actions/popoverActions';
import { handleActions } from 'redux-actions';

const initialState = {};

export default handleActions({
  [POPOVER_TYPES.SHOW_POPOVER]: (state, action) =>
    Object.assign({}, action.content, action.data),
  [POPOVER_TYPES.HIDE_POPOVER]: () => initialState,
  [POPOVER_TYPES.TOGGLE_POPOVER]: (state, action) => {
    let newState = initialState;

    if (action.content.id !== state.id) {
      newState = Object.assign({}, action.content, action.data);
    }

    return newState;
  },
}, initialState);



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/popoverReducer.js
 **/